export const defaultUomFactorValue = 1;
